import { Component, OnInit, Input, SimpleChanges, ViewChild } from '@angular/core';
import { LoggedLandingPageService } from 'src/app/core/services/logged-landing-page.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any;

@Component({
  selector: 'app-music',
  templateUrl: './music.component.html',
  styleUrls: ['./music.component.scss']
})
export class MusicComponent implements OnInit {

  @Input() whichSection;
  @Input() contentId;
  @Input() passRoute;
  @Input() tabSeleted;
  music: [];
  isError: boolean = false;
  errorMessage: string;
  imgURL: any = API_ENDPOINTS.BASE_URL;
  slider: any;
  currentUser: any;
  @Input() musicData;
  @Input() isSearch;
  @ViewChild('owlCarousel', { static: false }) owlCarousel: any;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    autoWidth: true,
    navSpeed: 500,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      },
      1199: {
        items: 6
      }
    },
    nav: true
  }
  constructor(
    private _authService: AuthService,
    private _router: Router) { }

  ngOnInit() {
    this.currentUser = this._authService.getCurrentUser();
  }

  disableLeftClick(event: MouseEvent): void {
    if (event.button === 0) {
      event.preventDefault(); // Prevent the default left-click behavior
    }
  }

  musicClick(id) {
    if (this._authService.isLoggednIn()) {
      if(this.passRoute){
        // console.log(this.passRoute);
        this._router.navigate(['/material-detail-page', id, 'public'], { queryParams: { whichRoute: this.passRoute, whichSection: 'audio',tabSeleted:this.tabSeleted } })
      } else {
        this._router.navigate(['/material-detail-page', id, 'public'])
      }
    }
    else {
      this._router.navigate(['/material-detail', id, 'public'])
    }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.musicData.currentValue.length > 2) {
  //     const _this = this;
  //     setTimeout(function () {
  //       // _this.loadSlider();
  //     }, 500);
  //   }

  // }

  ngOnChanges(changes: SimpleChanges) {
    const limit = (this.isSearch) ? 7 : 5;
    if (changes && changes.musicData && changes.musicData.currentValue.length > 0 && changes.musicData.currentValue.length < limit) {
      this.customOptions.responsive['1199'].items = changes.musicData.currentValue.length;
      this.customOptions.loop = false;
    }else if(changes && changes.musicData && changes.musicData.currentValue.length >= limit){
      this.customOptions.loop = true;
      this.customOptions.responsive['1199'].items = limit;
    }
    if(this.contentId && this.whichSection === 'audio'){
      this.owlCarousel.to(this.contentId);
    }
  }

  // slideNext() {
  //   this.slider.slick("slickNext");
  // }

  // slidePrevious() {
  //   this.slider.slick("slickPrev");
  // }

  // loadSlider() {
  //   if (this.slider) {
  //     $('.data-slick-music').slick('unslick');
  //   }
  //   this.slider = $(".data-slick-music").slick({
  //     centerMode: false,
  //     slidesToShow: 4,
  //     slidesToScroll: 3,
  //     autoplay: false,
  //     infinite: true,
  //     arrows: false,
  //     speed: 850,
  //     variableWidth: true,
  //     responsive: [
  //       {
  //         breakpoint: 1199,
  //         settings: {
  //           slidesToShow: 4,
  //           slidesToScroll: 3,
  //           infinite: true,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: '45px',
  //         }
  //       },
  //       {
  //         breakpoint: 991,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //           centerMode: false,
  //           centerPadding: '15px',
  //           speed: 500,
  //         }
  //       }
  //       // You can unslick at a given breakpoint now by adding:
  //       // settings: "unslick"
  //       // instead of a settings object
  //     ]
  //   });
  //   this.slider.on('wheel', (function (e) {
  //     e.preventDefault();

  //     if (e.originalEvent.deltaY < 0) {
  //       $(this).slick('slickNext');
  //     } else {
  //       $(this).slick('slickPrev');
  //     }
  //   }));
  // }

  // initializeSlider() {
  //   const _this = this;
  //   if (this.musicData && this.musicData.length > 4) {
  //     setTimeout(() => {
  //       _this.owlCarousel.el.nativeElement.onwheel = function (e) {
  //         e.preventDefault();
  //         if (e.deltaY < 0) {
  //           _this.owlCarousel.next();
  //         } else {
  //           _this.owlCarousel.prev();
  //         }
  //         e.preventDefault();
  //       };
  //     }, 100);

  //   }
  // }
}
